import _ from 'underscore';
import type { InstrumentationLog, PerfTimingProcessorOptions } from '../types';

export class PerfTimingProcessor {
  landingPageUrl: string;
  constructor({ landingPageUrl = '' }: PerfTimingProcessorOptions) {
    this.landingPageUrl = landingPageUrl;
  }

  process(rawLogs: InstrumentationLog) {
    return _.extend(rawLogs, {
      href: window.location.href,
      referrer: document.referrer,
      landingPg: this.landingPageUrl,
    });
  }
}
